import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const DEACTIVATE_ACCOUNT_MUTATION = gql`
  mutation deactivateAccount($id: String) {
    deactivateAccount(where: { id: $id }) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeactivateAccountMutation extends Mutation<RootMutation> {
  document = DEACTIVATE_ACCOUNT_MUTATION;
}
